import { ShortcutScope, ShortcutSettings, ShortcutStatus, ShortcutType } from "react-keyhub";

// Define custom shortcuts type extending the default ones
export const myShortcuts: ShortcutSettings = {

  showShortcuts: {
    keyCombo: "ctrl+/",
    name: "Show Shortcuts",
    description: "To Show the Keyboard Shortcuts",
    scope: "global" as ShortcutScope,
    priority: 100,
    status: ShortcutStatus.ENABLED,
    group: "Custom",
    type: ShortcutType.REGULAR,
  },

  closeForm: {
    keyCombo: "esc",
    name: "Close Form",
    description: "Close the Form",
    scope: "global" as ShortcutScope,
    priority: 100,
    status: ShortcutStatus.ENABLED,
    group: "Custom",
    type: ShortcutType.REGULAR,
  },
  saveForm: {
    keyCombo: "f3",
    name: "Save Form",         // Change this if needed
    description: "Save the Form",
    scope: "global" as ShortcutScope,
    priority: 100,
    status: ShortcutStatus.ENABLED,
    group: "Custom",
    type: ShortcutType.REGULAR,
  },
  saveandCloseForm: {
    keyCombo: "f4",
    name: "Save & Close Form", // Update name to differentiate
    description: "Save and Close the Form",
    scope: "global" as ShortcutScope,
    priority: 100,
    status: ShortcutStatus.ENABLED,
    group: "Custom",
    type: ShortcutType.REGULAR,
  },
};
export const shortcut_keys_settings = {
  visable_keys: true,
  enableshortcuts: true,
}
